// import { TextField, InputAdornment } from "@mui/material";
// import { EnvelopeIcon } from "@heroicons/react/24/outline";
// import React from "react";

// interface EmailFieldProps {
//   label: string;
//   name: string;
//   value: string;
//   onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
//   required?: boolean;
//   error?: boolean;
//   helperText?: string;
// }

// const EmailField: React.FC<EmailFieldProps> = ({
//   label,
//   name,
//   value,
//   onChange,
//   required = false,
//   error = false,
//   helperText = "",
// }) => {
//   return (
//     <TextField
//       fullWidth
//       required={required}
//       label={label}
//       name={name}
//       type="email"
//       error={error}
//       helperText={helperText}
//       value={value}
//       onChange={onChange}
//       InputProps={{
//         startAdornment: (
//           <InputAdornment position="start">
//             <EnvelopeIcon className="h-5 w-5 text-gray-500" />
//           </InputAdornment>
//         ),
//       }}
//     />
//   );
// };

// export default EmailField;

import { TextField, InputAdornment } from "@mui/material";
import { EnvelopeIcon } from "@heroicons/react/24/outline";
import React,{useState, useEffect} from "react";

interface EmailFieldProps {
    label: string;
    name: string;
    value: string;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    required?: boolean;
    validate?: boolean; 
    showError?: boolean;
    disabled?: boolean;
  }
  
  const EmailField: React.FC<EmailFieldProps> = ({
    label,
    name,
    value,
    onChange,
    required = false,
    validate = true,
    showError = true,
    disabled = false,
  }) => {
    const [error, setError] = useState(false);
    const [helperText, setHelperText] = useState("");
  
    useEffect(() => {
      if (validate) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!value) {
          setError(required);
          setHelperText(required ? "Email is required" : "");
        } else if (!emailRegex.test(value)) {
          setError(true);
          setHelperText("Invalid email format");
        } else {
          setError(false);
          setHelperText("");
        }
      }
    }, [value, validate, required]);
  
    return (
      <TextField
        fullWidth
        required={required}
        label={label}
        name={name}
        type="email"
        value={value}
        onChange={onChange}
        disabled={disabled}
        // error={error}
        // helperText={helperText}
        error={showError && error}
        helperText={showError && error ? helperText : ""}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <EnvelopeIcon className="h-5 w-5 text-gray-500" />
            </InputAdornment>
          ),
        }}
      />
    );
  };
  
  export default EmailField;